<template>
  <b-row>
    <b-col class="col-12 col-md-4">
      <input-text
        ref="ano"
        label="Ano"
        required
        v-model="form.ano"
        :maxLength="4"
        :showLengthLimit="false"
        type="number"
      />
    </b-col>

    <b-col class="col-12 col-md-4">
      <input-date-only-btn
        ref="inicioLetivo"
        label="Início letivo"
        required
        v-model="form.dataInicio"
      />
    </b-col>

    <b-col class="col-12 col-md-4">
      <input-date-only-btn
        ref="fimLetivo"
        label="Fim letivo"
        required
        v-model="form.dataFim"
      />
    </b-col>

    <b-col class="col-12 col-md-4">
      <input-date-only-btn
        ref="inicioMatricula"
        label="Início rematrícula"
        required
        v-model="form.dataInicioRematricula"
      />
    </b-col>

    <b-col class="col-12 col-md-4">
      <input-date-only-btn
        ref="fimMatricula"
        label="Fim rematrícula"
        required
        v-model="form.dataFimRematricula"
      />
    </b-col>

    <b-col class="col-12 col-md-4">
      <input-select
        :options="opcoes.anosLetivos"
        v-model="form.anoLetivoAntecessorId"
        valueField="id"
        textField="ano"
        label="Período letivo antecessor"
        placeholder="Selecione ou digite"
        :loading="loadingAnosLetivos"
      />
    </b-col>

    <b-col class="col-12 col-md-4">
      <input-select
        ref="statusLiberacao"
        :options="opcoes.statusLiberacao"
        v-model="form.statusLiberacao"
        valueField="id"
        textField="descricao"
        label="Status"
        placeholder="Selecione ou digite"
        required
        :loading="loadingStatusLiberacao"
      />
    </b-col>

    <b-col class="col-12 col-md-4">
      <input-select
        ref="regraRecuperacaoSegmentacao"
        :options="opcoes.regraRecuperacaoSegmentacao"
        v-model="form.regraRecuperacaoSegmentacao"
        valueField="id"
        textField="descricao"
        label="Regra de recuperação de segmentação"
        placeholder="Selecione ou digite"
        required
        :loading="loadingRegraRecuperacaoSegmentacao"
      />
    </b-col>

    <b-col class="col-12 col-md-4">
      <input-select
        ref="habilitarAvaliacaoFinal"
        :options="opcoes.habilitarAvaliacaoFinal"
        v-model="habilitarAvaliacaoFinalSelect"
        valueField="id"
        textField="descricao"
        label="Habilitar Avaliação Final"
        placeholder="Selecione ou digite"
        required
      />
    </b-col>

    <b-col class="col-12 col-md-4">
      <input-select
        ref="grupoTurmaLimiteIntegral"
        :options="opcoes.gruposTurmaLetivo"
        v-model="form.grupoTurmaLimiteIntegralId"
        valueField="value"
        textField="text"
        label="Série limite do Integral"
        placeholder="Selecione ou digite"
        :loading="loadingGruposTurmaLetivo"
      />
    </b-col>

    <b-col class="col-12 col-md-4">
      <input-select
        ref="grupoTurmaIntegralDestino"
        :options="opcoes.gruposTurmaIntegral"
        v-model="form.grupoTurmaIntegralDestinoId"
        valueField="value"
        textField="text"
        label="Grupo de turma de destino do Integral"
        placeholder="Selecione ou digite"
        :loading="loadingGruposTurmaIntegral"
      />
    </b-col>
  </b-row>
</template>

<script>
import AnoLetivoService from '@/common/services/anoLetivo/ano-letivo.service';
import GrupoTurmaService from '@/common/services/grupoTurma/grupo-turma.service';
import EnumeradoresService from '@/common/services/enumeradores/enumeradores.service';
import mensagem from '@/common/utils/mensagem';

import { InputText, InputDateOnlyBtn, InputSelect } from '@/components/inputs';

export default {
  components: {
    InputText,
    InputDateOnlyBtn,
    InputSelect,
  },
  props: {
    form: { type: Object, default: Object },
  },
  mounted() {
    this.getStatusLiberacao();
    this.getRegraRecuperacaoSegmentacao();
    this.getAnosLetivo();
    this.getGruposTurmaLetivo();
    this.getGruposTurmaIntegral();
    this.capturarRefs(this.$refs);
  },
  data() {
    return {
      opcoes: {
        anosLetivos: [],
        statusLiberacao: [],
        regraRecuperacaoSegmentacao: [],
        gruposTurmaLetivo: [],
        gruposTurmaIntegral: [],
        habilitarAvaliacaoFinal: [
          { id: 1, descricao: 'Habilitada' },
          { id: 2, descricao: 'Desabilitada' },
        ],
      },
      refs: [],
      loadingAnosLetivos: false,
      loadingStatusLiberacao: false,
      loadingRegraRecuperacaoSegmentacao: false,
      loadingGruposTurmaLetivo: false,
      loadingGruposTurmaIntegral: false,
    };
  },
  computed: {
    habilitarAvaliacaoFinalSelect: {
      get() {
        if (this.form?.avaliacaoFinal === true) return 1;
        if (this.form?.avaliacaoFinal === false) return 2;
        return null;
      },
      set(val) {
        if (val === 1) this.form.avaliacaoFinal = true;
        if (val === 2) this.form.avaliacaoFinal = false;
      },
    },
  },
  methods: {
    getAnosLetivo() {
      this.loadingAnosLetivos = true;
      AnoLetivoService.listar()
        .then(({ data }) => {
          this.opcoes.anosLetivos = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.loadingAnosLetivos = false;
        });
    },

    getGruposTurmaLetivo() {
      this.loadingGruposTurmaLetivo = true;
      GrupoTurmaService.buscarOpcoesGrupoTurma(284)
        .then((data) => {
          this.opcoes.gruposTurmaLetivo = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.loadingGruposTurmaLetivo = false;
        });
    },

    getGruposTurmaIntegral() {
      this.loadingGruposTurmaIntegral = true;
      GrupoTurmaService.buscarOpcoesGrupoTurma(525)
        .then((data) => {
          this.opcoes.gruposTurmaIntegral = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.loadingGruposTurmaIntegral = false;
        });
    },

    getStatusLiberacao() {
      this.loadingStatusLiberacao = true;
      EnumeradoresService.listar('status-liberacao')
        .then(({ data }) => {
          data = data.map((row) => ({
            ...row,
            text: row.descricao,
            value: row.id,
          }));

          this.opcoes.statusLiberacao = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.loadingStatusLiberacao = false;
        });
    },

    getRegraRecuperacaoSegmentacao() {
      this.loadingRegraRecuperacaoSegmentacao = true;
      EnumeradoresService.listar('regra-recuperacao-segmentacao')
        .then(({ data }) => {
          data = data.map((row) => ({
            ...row,
            text: row.descricao,
            value: row.id,
          }));

          this.opcoes.regraRecuperacaoSegmentacao = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.loadingRegraRecuperacaoSegmentacao = false;
        });
    },
    capturarRefs(refs) {
      this.refs = refs;
      this.$emit('refs', this.refs);
    },
  },
};
</script>
